import { z } from 'zod';

export const TranslateResponseSchema = z.object({
  translation: z.string(),
});

export type ITranslateResponseDto = z.infer<typeof TranslateResponseSchema>;
